import React, { useEffect, useState, useMemo, useContext } from 'react';
import {
  FormSelect,
  FilterWidget,
  MasterDetailForm,
  FormSubmitButton,
  Button,
  FormInput,
  FormDatePicker,
  usePromise,
  OptionProps,
  FormNumber,
} from '@digital/ui';
import { useActions } from 'easy-peasy';
import { getAllOptionsStatusModuloEconomicoContratado } from '@app/api/statusModuloEconmicoContratado';
import { getAllStatusRequisicaoCompraSeqOptions } from '@app/api/status';
import { PropFormulario } from '@app/api/ctrPcs';
import ptBr from '../../i18n/ptBR/index';

const FiltrosPcs = (props: { onSearch: Function; atualizarTela: Function; }) => {
  var trocarDeValor = [true, false];
  const { onSearch, atualizarTela } = props;
  const toggleMenuFullCollapse = useActions(state => state.ui.toggleMenuFullCollapse);
  const [statusModuloEconomicoContratado] = usePromise(
    getAllOptionsStatusModuloEconomicoContratado,
    [],
    [] as OptionProps[],
  );
  const [statusRequisicaoCompraSeqOptions] = usePromise(
    getAllStatusRequisicaoCompraSeqOptions,
    [],
    [] as OptionProps[],
  );
  const [valorInicial, setValorInicial] = useState<PropFormulario>({} as PropFormulario);

  const [trocarValor, setTrocarValor] = useState<boolean>(trocarDeValor.reverse()[0]);

  useEffect(() => {
    // toggleMenuFullCollapse(); Collapse menu on load page
  }, []);

  const limparFormulario = () => {
    const trocarValorTeste = trocarValor;
    setTrocarValor(!trocarValor);
    setValorInicial({
      centroCustoFormulario: '',
      contaContabilFormulario: '',

      codigoProjetoFormulario: ``,
      nomeProjetoFormulario: '',
      statusModuloEconomicoContratadoFormulario: [],
      codigoOrdemInvestimentoFormulario: '',
      nomeOrdemInvestimentoFormulario: '',
      numeroOrdemInvestimentoFormulario: '',

      numeroRequisicaoCompraFormulario: '',

      numeroItemRequisicaoCompraFormulario: '',
      statusRequisicaoCompraFormulario: [],

      numeroOrdemCompraFormulario: '',
      dataEmissaoOrdemCompraFormulario: '',

      numeroPedidoCompraFormulario: '',
      tipoPedidoCompraFormulario: '',

      nomeFornecedorPedidoCompraFormulario: '',
      numeroContratoPcsFormulario: '',
      mudarValor: trocarValorTeste,
    });
    atualizarTela();
  };

  return (
    <MasterDetailForm key="filtroPesquisa" initialValues={valorInicial} onSubmit={onSearch}>
      <FilterWidget
        title="FILTROS DE PESQUISA"
        actions={[
          <Button
            type="link"
            title="Limpar"
            onClick={() => {
              limparFormulario();
            }}
          />,
          <FormSubmitButton icon={'commons-search'}>Pesquisar</FormSubmitButton>,
        ]}>
        <div className="ant-row">
          <FormInput
            name="centroCustoFormulario"
            id="centroCustoFormulario"
            label={ptBr.numeroCentroDeCusto}
            span={3}
            allowClear
          />
          <FormInput
            name="contaContabilFormulario"
            id="contaContabilFormulario"
            label={ptBr.numeroContaContabil}
            span={3}
            allowClear
          />
        </div>

        <div className="ant-row">
          <FormNumber
            name="numeroRequisicaoCompraFormulario"
            id="numeroRequisicaoCompraFormulario"
            label={ptBr.numeroRequisicaoDeCompra}
            span={3}
          />
          <FormNumber
            name="numeroItemRequisicaoCompraFormulario"
            id="numeroItemRequisicaoCompraFormulario"
            label={ptBr.itemRequisicaoCompra}
            span={3}
          />

          <FormSelect
            showSearch
            optionFilterProp="children"
            filterOption={(input, item) => {
              return item.props.children.props.id
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            mode="multiple"
            name="statusRequisicaoCompraFormulario"
            id="statusRequisicaoCompraFormulario"
            label={ptBr.statusRequisicaoCompra}
            options={statusRequisicaoCompraSeqOptions}
            span={3}
            allowClear
          />
        </div>

        <div className="ant-row">
          <FormNumber
            name="numeroOrdemCompraFormulario"
            id="numeroOrdemCompraFormulario"
            label={ptBr.numeroOrdemDeCompra}
            span={3}
          />

          <FormDatePicker
            name="dataEmissaoOrdemCompraFormulario"
            id="dataEmissaoOrdemCompraFormulario"
            label={ptBr.dataEmissaoOrdemDeCompra}
            span={3}
            format="DD/MM/YYYY"
            allowClear
          />
        </div>

        <div className="ant-row">
          <FormNumber
            name="numeroPedidoCompraFormulario"
            id="numeroPedidoCompraFormulario"
            label={ptBr.numeroPedido}
            span={3}
            allowClear
          />
          <FormInput
            name="tipoPedidoCompraFormulario"
            id="tipoPedidoCompraFormulario"
            label={ptBr.tipoPedido}
            span={3}
            allowClear
          />
          <FormInput
            name="nomeFornecedorPedidoCompraFormulario"
            id="nomeFornecedorPedidoCompraFormulario"
            label={ptBr.nomeFornecedor}
            span={3}
            allowClear
          />
        </div>

        <div className="ant-row">
          <FormNumber
            name="numeroContratoPcsFormulario"
            id="numeroContratoPcsFormulario"
            label={ptBr.numeroContratado}
            span={3}
          />
        </div>
      </FilterWidget>
    </MasterDetailForm>
  );
};

export default FiltrosPcs;
